module.exports = __webpack_public_path__ + "static/media/H1.029accd8.png";